import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import CandlestickFinder from "./CandlestickFinder";

var EveningStar =
/*#__PURE__*/
function (_CandlestickFinder) {
  _inherits(EveningStar, _CandlestickFinder);

  function EveningStar() {
    var _this;

    _classCallCheck(this, EveningStar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EveningStar).call(this));
    _this.name = "EveningStar";
    _this.requiredCount = 3;
    return _this;
  }

  _createClass(EveningStar, [{
    key: "logic",
    value: function logic(data) {
      var firstdaysOpen = data.open[0];
      var firstdaysClose = data.close[0];
      var firstdaysHigh = data.high[0];
      var firstdaysLow = data.low[0];
      var seconddaysOpen = data.open[1];
      var seconddaysClose = data.close[1];
      var seconddaysHigh = data.high[1];
      var seconddaysLow = data.low[1];
      var thirddaysOpen = data.open[2];
      var thirddaysClose = data.close[2];
      var thirddaysHigh = data.high[2];
      var thirddaysLow = data.low[2];
      var firstdaysMidpoint = (firstdaysOpen + firstdaysClose) / 2;
      var isFirstBullish = firstdaysClose > firstdaysOpen;
      var isSmallBodyExists = firstdaysHigh < seconddaysLow && firstdaysHigh < seconddaysHigh;
      var isThirdBearish = thirddaysOpen > thirddaysClose;
      var gapExists = seconddaysHigh > firstdaysHigh && seconddaysLow > firstdaysHigh && thirddaysOpen < seconddaysLow && seconddaysClose > thirddaysOpen;
      var doesCloseBelowFirstMidpoint = thirddaysClose < firstdaysMidpoint;
      return isFirstBullish && isSmallBodyExists && gapExists && isThirdBearish && doesCloseBelowFirstMidpoint;
    }
  }]);

  return EveningStar;
}(CandlestickFinder);

export { EveningStar as default };
export function eveningstar(data) {
  return new EveningStar().hasPattern(data);
}